interface IIconProps {
  size?: number;
  color?: string;
  width?: string;
  height?: string;
}

export const InfoIcon = ({ size = 24 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    className="r-1ghhsy9 r-1kb76zh"
    height={size}
    width={size}
  >
    <g fill="currentColor" clipPath="url(#InfoCircle_svg__a)">
      <path
        fillRule="evenodd"
        d="M8 1.6a6.4 6.4 0 1 0 0 12.8A6.4 6.4 0 0 0 8 1.6ZM.4 8a7.6 7.6 0 1 1 15.2 0A7.6 7.6 0 0 1 .4 8Z"
        clipRule="evenodd"
      ></path>
      <path
        fillRule="evenodd"
        d="M5.4 7a.6.6 0 0 1 .6-.6h2a.6.6 0 0 1 .6.6v3.9H10a.6.6 0 0 1 0 1.2H6a.6.6 0 1 1 0-1.2h1.4V7.6H6a.6.6 0 0 1-.6-.6Z"
        clipRule="evenodd"
      ></path>
      <path d="M8 3.6a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Z"></path>
    </g>
    <defs>
      <clipPath id="InfoCircle_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const TrashIconV3 = ({ size = 24, color = 'white' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0264 14.2105H28.9737M17.1316 18.9473V26.0526M21.8685 18.9473V26.0526M11.2106 14.2105L12.3948 28.421C12.3948 29.0491 12.6443 29.6516 13.0885 30.0957C13.5326 30.5399 14.1351 30.7894 14.7632 30.7894H24.2369C24.865 30.7894 25.4675 30.5399 25.9116 30.0957C26.3558 29.6516 26.6053 29.0491 26.6053 28.421L27.7895 14.2105M15.9474 14.2105V10.6578C15.9474 10.3438 16.0722 10.0426 16.2943 9.82048C16.5163 9.5984 16.8176 9.47363 17.1316 9.47363H21.8685C22.1825 9.47363 22.4838 9.5984 22.7058 9.82048C22.9279 10.0426 23.0527 10.3438 23.0527 10.6578V14.2105"
      stroke={color}
      strokeWidth="1.77632"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DomainIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.66663C5.40002 1.66663 1.66669 5.39996 1.66669 9.99996C1.66669 14.6 5.40002 18.3333 10 18.3333C14.6 18.3333 18.3334 14.6 18.3334 9.99996C18.3334 5.39996 14.6 1.66663 10 1.66663ZM3.33335 9.99996C3.33335 9.49163 3.40002 8.99163 3.50835 8.51663L7.49169 12.5V13.3333C7.49169 14.25 8.24169 15 9.15835 15V16.6083C5.88335 16.1916 3.33335 13.3916 3.33335 9.99996ZM14.9084 14.5C14.6917 13.825 14.075 13.3333 13.325 13.3333H12.4917V10.8333C12.4917 10.375 12.1167 9.99996 11.6584 9.99996H6.65835V8.33329H8.32502C8.78335 8.33329 9.15835 7.95829 9.15835 7.49996V5.83329H10.825C11.7417 5.83329 12.4917 5.08329 12.4917 4.16663V3.82496C14.9334 4.80829 16.6667 7.20829 16.6667 9.99996C16.6667 11.7333 15.9917 13.3166 14.9084 14.5Z"
      fill="#979797"
    ></path>
  </svg>
);
export const CloneIcon = () => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="color_stroke"
      d="M9.3 5C9.3 7.37482 7.37482 9.3 5 9.3C2.62518 9.3 0.7 7.37482 0.7 5C0.7 2.62518 2.62518 0.7 5 0.7C7.37482 0.7 9.3 2.62518 9.3 5Z"
      stroke="#979797"
      strokeWidth="1.4"
    ></path>
    <path
      className="color_fill"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 10C13.7614 10 16 7.76142 16 5C16 2.23858 13.7614 0 11 0C8.23858 0 6 2.23858 6 5C6 7.76142 8.23858 10 11 10Z"
      fill="#979797"
    ></path>
  </svg>
);
export const WarningIcon = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7704 13.5393L11.9383 1.67446C11.7404 1.33603 11.4574 1.05531 11.1173 0.860229C10.7773 0.665147 10.3921 0.5625 10 0.5625C9.60801 0.5625 9.22281 0.665147 8.88276 0.860229C8.5427 1.05531 8.25966 1.33603 8.06177 1.67446L1.22974 13.5393C1.03772 13.8677 0.936523 14.2413 0.936523 14.6217C0.936523 15.0022 1.03772 15.3757 1.22974 15.7041C1.42543 16.0443 1.70809 16.3262 2.04871 16.521C2.38933 16.7158 2.77564 16.8165 3.16802 16.8127H16.8321C17.2242 16.8162 17.6102 16.7154 17.9505 16.5206C18.2908 16.3258 18.5732 16.044 18.7688 15.7041C18.9611 15.3759 19.0625 15.0024 19.0628 14.6219C19.0631 14.2415 18.9621 13.8679 18.7704 13.5393ZM17.1454 14.7659C17.1136 14.82 17.0678 14.8646 17.0128 14.8948C16.9578 14.9251 16.8956 14.9399 16.8329 14.9377H3.16802C3.10528 14.9399 3.04312 14.9251 2.98811 14.8948C2.9331 14.8646 2.88729 14.82 2.85552 14.7659C2.82857 14.722 2.8143 14.6716 2.8143 14.6202C2.8143 14.5687 2.82857 14.5183 2.85552 14.4745L9.68755 2.60961C9.72138 2.55754 9.76769 2.51475 9.82226 2.48512C9.87684 2.45549 9.93795 2.43998 10 2.43998C10.0621 2.43998 10.1233 2.45549 10.1778 2.48512C10.2324 2.51475 10.2787 2.55754 10.3125 2.60961L17.1438 14.4745C17.171 14.5181 17.1855 14.5685 17.1858 14.6199C17.1861 14.6714 17.1721 14.7219 17.1454 14.7659ZM9.06255 9.62524V7.12524C9.06255 6.8766 9.16132 6.63814 9.33714 6.46233C9.51295 6.28651 9.75141 6.18774 10 6.18774C10.2487 6.18774 10.4871 6.28651 10.663 6.46233C10.8388 6.63814 10.9375 6.8766 10.9375 7.12524V9.62524C10.9375 9.87388 10.8388 10.1123 10.663 10.2882C10.4871 10.464 10.2487 10.5627 10 10.5627C9.75141 10.5627 9.51295 10.464 9.33714 10.2882C9.16132 10.1123 9.06255 9.87388 9.06255 9.62524ZM11.25 12.7502C11.25 12.9975 11.1767 13.2391 11.0394 13.4447C10.902 13.6503 10.7068 13.8105 10.4784 13.9051C10.25 13.9997 9.99866 14.0245 9.75619 13.9762C9.51371 13.928 9.29098 13.8089 9.11617 13.6341C8.94135 13.4593 8.8223 13.2366 8.77407 12.9941C8.72584 12.7516 8.75059 12.5003 8.8452 12.2719C8.93981 12.0435 9.10003 11.8483 9.30559 11.7109C9.51115 11.5735 9.75282 11.5002 10 11.5002C10.3316 11.5002 10.6495 11.6319 10.8839 11.8664C11.1184 12.1008 11.25 12.4187 11.25 12.7502Z"
      fill="#E8C822"
    />
  </svg>
);

export const AlertIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0.25C4.16797 0.25 0.25 4.16797 0.25 9C0.25 13.832 4.16797 17.75 9 17.75C13.832 17.75 17.75 13.832 17.75 9C17.75 4.16797 13.832 0.25 9 0.25ZM9 16.2656C4.98828 16.2656 1.73438 13.0117 1.73438 9C1.73438 7.26172 2.3457 5.66406 3.36523 4.41406L13.5859 14.6348C12.3359 15.6543 10.7383 16.2656 9 16.2656ZM14.6348 13.5859L4.41406 3.36523C5.66406 2.3457 7.26172 1.73438 9 1.73438C13.0117 1.73438 16.2656 4.98828 16.2656 9C16.2656 10.7383 15.6543 12.3359 14.6348 13.5859Z"
      fill="#E85D22"
    />
  </svg>
);

export const InfoShowIcon = ({ size = 52 }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3203 1V11.5272"
      stroke="white"
      strokeWidth="1.34211"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.6836 24.6836L51.0014 29.9472L43.106 35.2108L51.0014 43.1062L43.106 51.0016L35.2107 43.1062L29.9471 51.0016L24.6836 24.6836Z"
      stroke="white"
      strokeWidth="1.34211"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.9271 8.71094L38.4831 16.155M8.70847 45.9299L16.1525 38.4858M1 27.3204H11.5271M8.70847 8.71094L16.1525 16.155"
      stroke="white"
      strokeWidth="1.34211"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ManageVisibiltiyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.50033 11.4596C5.55033 11.4596 1.66699 12.4346 1.66699 14.3763V15.8346H13.3337V14.3763C13.3337 12.4346 9.45033 11.4596 7.50033 11.4596ZM3.61699 14.168C4.31699 13.6846 6.00866 13.1263 7.50033 13.1263C8.99199 13.1263 10.6837 13.6846 11.3837 14.168H3.61699ZM7.50033 10.0013C9.10866 10.0013 10.417 8.69297 10.417 7.08464C10.417 5.4763 9.10866 4.16797 7.50033 4.16797C5.89199 4.16797 4.58366 5.4763 4.58366 7.08464C4.58366 8.69297 5.89199 10.0013 7.50033 10.0013ZM7.50033 5.83464C8.19199 5.83464 8.75033 6.39297 8.75033 7.08464C8.75033 7.7763 8.19199 8.33464 7.50033 8.33464C6.80866 8.33464 6.25033 7.7763 6.25033 7.08464C6.25033 6.39297 6.80866 5.83464 7.50033 5.83464ZM13.367 11.5096C14.3337 12.2096 15.0003 13.143 15.0003 14.3763V15.8346H18.3337V14.3763C18.3337 12.693 15.417 11.7346 13.367 11.5096V11.5096ZM12.5003 10.0013C14.1087 10.0013 15.417 8.69297 15.417 7.08464C15.417 5.4763 14.1087 4.16797 12.5003 4.16797C12.0503 4.16797 11.6337 4.2763 11.2503 4.45964C11.7753 5.2013 12.0837 6.10964 12.0837 7.08464C12.0837 8.05964 11.7753 8.96797 11.2503 9.70964C11.6337 9.89297 12.0503 10.0013 12.5003 10.0013Z"
      fill="#979797"
    ></path>
  </svg>
);

export const CloneIconV2 = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.98364 10.6936C5.98364 7.98887 5.98364 6.63555 6.82433 5.79582C7.66406 4.95514 9.01738 4.95514 11.7221 4.95514H14.5913C17.2961 4.95514 18.6494 4.95514 19.4891 5.79582C20.3298 6.63555 20.3298 7.98887 20.3298 10.6936V15.4757C20.3298 18.1804 20.3298 19.5337 19.4891 20.3734C18.6494 21.2141 17.2961 21.2141 14.5913 21.2141H11.7221C9.01738 21.2141 7.66406 21.2141 6.82433 20.3734C5.98364 19.5337 5.98364 18.1804 5.98364 15.4757V10.6936Z"
      stroke="white"
      strokeWidth="1.46166"
    />
    <path
      d="M5.98361 18.3448C5.22264 18.3448 4.49284 18.0425 3.95476 17.5044C3.41667 16.9664 3.11438 16.2366 3.11438 15.4756V9.73713C3.11438 6.1305 3.11438 4.32672 4.23529 3.20676C5.35525 2.08585 7.15904 2.08585 10.7657 2.08585H14.5913C15.3523 2.08585 16.0821 2.38814 16.6202 2.92622C17.1582 3.46431 17.4605 4.19411 17.4605 4.95508"
      stroke="white"
      strokeWidth="1.46166"
    />
  </svg>
);
export const ForwardIcon = ({ size = 20, color = '#787878' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1667 7.5013V7.93495L11.7374 7.99628C9.03728 8.382 7.10695 9.50419 5.73833 10.9925C4.75176 12.0654 4.04553 13.3415 3.55994 14.6956C5.60747 12.7914 8.2571 11.918 11.6667 11.918H12.1667V12.418V14.6275L16.7929 10.0013L12.1667 5.37508V7.5013Z"
      fill={color}
      stroke={color}
    ></path>
  </svg>
);

export const ReviewIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 18.7125L20.85 20.4375C21.125 20.6125 21.4 20.6065 21.675 20.4195C21.95 20.2325 22.05 19.976 21.975 19.65L21.225 16.3875L23.775 14.175C24.025 13.95 24.1 13.6815 24 13.3695C23.9 13.0575 23.675 12.8885 23.325 12.8625L19.9875 12.6L18.675 9.525C18.55 9.225 18.325 9.075 18 9.075C17.675 9.075 17.45 9.225 17.325 9.525L16.0125 12.6L12.675 12.8625C12.325 12.8875 12.1 13.0565 12 13.3695C11.9 13.6825 11.975 13.951 12.225 14.175L14.775 16.3875L14.025 19.65C13.95 19.975 14.05 20.2315 14.325 20.4195C14.6 20.6075 14.875 20.6135 15.15 20.4375L18 18.7125ZM9 27L5.55 30.45C5.075 30.925 4.531 31.0315 3.918 30.7695C3.305 30.5075 2.999 30.0385 3 29.3625V6C3 5.175 3.294 4.4685 3.882 3.8805C4.47 3.2925 5.176 2.999 6 3H30C30.825 3 31.5315 3.294 32.1195 3.882C32.7075 4.47 33.001 5.176 33 6V24C33 24.825 32.706 25.5315 32.118 26.1195C31.53 26.7075 30.824 27.001 30 27H9ZM7.725 24H30V6H6V25.6875L7.725 24Z"
      fill="white"
    />
  </svg>
);
export const RightArrowIcon = ({
  color = 'white',
  width = '12',
  height = '19',
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.147969 16.7417L7.28036 9.59375L0.147969 2.44578L2.34375 0.25L11.6875 9.59375L2.34375 18.9375L0.147969 16.7417Z"
      fill={color}
    />
  </svg>
);
export const BannerSwitchSelectedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <circle cx="8" cy="8.0625" r="8" fill="white" />
    <path
      d="M4 8.0625L6.5 10.5625L12 5.0625"
      stroke="#A46C37"
      strokeWidth="2"
    />
  </svg>
);
export const CloseIcon = ({
  width = '12',
  height = '12',
  color = 'white',
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={color}
  >
    <path d="M2 2L22 22" stroke={color} strokeOpacity="0.7" strokeWidth="3" />
    <path d="M22 2L2 22" stroke={color} strokeOpacity="0.7" strokeWidth="3" />
  </svg>
);
export const RotateIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9467_27895)">
      <path
        d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0C0.51 19.16 5.66 24 11.95 24C12.18 24 12.39 23.98 12.61 23.97L8.8 20.15L7.47 21.49ZM12.05 0C11.82 0 11.61 0.02 11.39 0.04L15.2 3.85L16.53 2.52C19.8 4.07 22.14 7.24 22.5 11H24C23.49 4.84 18.34 0 12.05 0ZM16 14H18V8C18 6.89 17.1 6 16 6H10V8H16V14ZM8 16V4H6V6H4V8H6V16C6 17.1 6.89 18 8 18H16V20H18V18H20V16H8Z"
        fill="white"
        fillOpacity="0.7"
      />
    </g>
    <defs>
      <clipPath id="clip0_9467_27895">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const GreenRightIconV2 = ({
  width,
  height,
  color = '#F8F8F8',
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 36 36"
    fill="green"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 24.6L9 18.6L11.1 16.5L15 20.4L24.9 10.5L27 12.6L15 24.6Z"
      fill={color}
    />
  </svg>
);
export const FacebookIcon = ({ width = '20' }: IIconProps) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9467_29446)">
      <path
        d="M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 35.9789 8.77641 45.908 20.25 47.7084V30.9375H14.1562V24H20.25V18.7125C20.25 12.6975 23.8331 9.375 29.3152 9.375C31.9402 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6613C28.68 15.75 27.75 17.6002 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7084C39.2236 45.908 48 35.9789 48 24Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9467_29446">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TwitterIconX = ({ width = '20' }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={width}
    viewBox="0 0 30 30"
    fill="white"
  >
    <path d="M26.37,26l-8.795-12.822l0.015,0.012L25.52,4h-2.65l-6.46,7.48L11.28,4H4.33l8.211,11.971L12.54,15.97L3.88,26h2.65 l7.182-8.322L19.42,26H26.37z M10.23,6l12.34,18h-2.1L8.12,6H10.23z"></path>
  </svg>
);

export const WhatsappIcon = ({ width = '20' }: IIconProps) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.3228 24.9328C29.805 24.6739 27.2756 23.4363 26.8018 23.2654C26.3306 23.092 25.9862 23.0065 25.6419 23.5243C25.3002 24.0344 24.3112 25.1891 24.0108 25.5308C23.7105 25.8674 23.4102 25.8933 22.8976 25.6603C22.3798 25.4014 20.7176 24.8577 18.75 23.0972C17.2173 21.725 16.1869 20.0421 15.8839 19.5243C15.5836 19.0065 15.8503 18.7217 16.1092 18.4628C16.3422 18.2298 16.627 17.8674 16.8859 17.5567C17.1396 17.246 17.2224 17.0389 17.3985 16.7023C17.5694 16.3398 17.4839 16.0551 17.3545 15.7962C17.225 15.5373 16.1946 13 15.7648 11.9903C15.3506 10.9806 14.9234 11.11 14.605 11.11C14.3072 11.0842 13.9629 11.0842 13.6212 11.0842C13.2742 11.0842 12.715 11.2136 12.2438 11.7055C11.7726 12.2233 10.4418 13.4661 10.4418 15.9774C10.4418 18.4887 12.2878 20.9224 12.5441 21.2849C12.803 21.6214 16.1791 26.7994 21.3467 29.026C22.5791 29.5438 23.537 29.8545 24.2878 30.1134C25.5202 30.5017 26.6438 30.4499 27.5319 30.3205C28.5235 30.1651 30.5817 29.0778 31.0115 27.8609C31.4516 26.6441 31.4516 25.6344 31.3222 25.4014C31.1927 25.1684 30.8562 25.0389 30.3384 24.8059M20.9377 37.65H20.9118C17.8568 37.65 14.8276 36.8215 12.1868 35.2681L11.5655 34.8978L5.09296 36.5807L6.82759 30.2894L6.41335 29.6422C4.7046 26.9237 3.79845 23.791 3.79845 20.5651C3.79845 11.167 11.4878 3.50356 20.9584 3.50356C25.5409 3.50356 29.8387 5.28998 33.0749 8.52624C36.3112 11.7366 38.0976 16.0344 38.0976 20.591C38.0898 29.9891 30.4005 37.6525 20.9506 37.6525M35.5397 6.06409C31.6044 2.25824 26.4264 0.109375 20.9118 0.109375C9.55123 0.109375 0.3033 9.31588 0.29553 20.635C0.29553 24.2519 1.2431 27.7807 3.04764 30.8978L0.12207 41.5335L11.0554 38.6804C14.069 40.3115 17.4606 41.1762 20.9118 41.1788H20.9221C32.2879 41.1788 41.541 31.9697 41.5462 20.648C41.5462 15.167 39.4051 10.0071 35.5138 6.12881"
      fill="white"
    />
  </svg>
);
export const SoundOnIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5.99998V12H4L9 17V0.99998L4 5.99998H0ZM13.5 8.99998C13.5 7.22998 12.48 5.70998 11 4.96998V13.02C12.48 12.29 13.5 10.77 13.5 8.99998ZM11 0.22998V2.28998C13.89 3.14998 16 5.82998 16 8.99998C16 12.17 13.89 14.85 11 15.71V17.77C15.01 16.86 18 13.28 18 8.99998C18 4.71998 15.01 1.13998 11 0.22998Z"
      fill="white"
    />
  </svg>
);
export const SoundOffIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9467_27410)">
      <path
        d="M16.5 12C16.5 10.23 15.48 8.71 14 7.97V10.18L16.45 12.63C16.48 12.43 16.5 12.22 16.5 12ZM19 12C19 12.94 18.8 13.82 18.46 14.64L19.97 16.15C20.63 14.91 21 13.5 21 12C21 7.72 18.01 4.14 14 3.23V5.29C16.89 6.15 19 8.83 19 12ZM4.27 3L3 4.27L7.73 9H3V15H7L12 20V13.27L16.25 17.52C15.58 18.04 14.83 18.45 14 18.7V20.76C15.38 20.45 16.63 19.81 17.69 18.95L19.73 21L21 19.73L12 10.73L4.27 3ZM12 4L9.91 6.09L12 8.18V4Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9467_27410">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const RightArrowIconV2 = ({ color = 'black' }: IIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99984 0.664062L6.70734 1.95656L11.8223 7.08073H0.666504V8.91406H11.8223L6.70734 14.0382L7.99984 15.3307L15.3332 7.9974L7.99984 0.664062Z"
      fill={color}
    />
  </svg>
);
export const CopyIcon = ({ color = '#928D97' }: IIconProps) => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.22422"
      y="0.65"
      width="13.3027"
      height="15.8905"
      rx="2.35"
      stroke={color}
      strokeWidth="1.3"
    />
    <path
      d="M2.82031 16.2858V16.2858C2.82031 17.7848 4.03554 19 5.5346 19H14.4231C16.0799 19 17.4231 17.6569 17.4231 16V4.80957C17.4231 3.15272 16.0799 1.80957 14.4231 1.80957H14.0532"
      stroke={color}
      strokeWidth="1.3"
    />
  </svg>
);
export const TriangleIcon = () => (
  <svg
    width="332"
    height="97"
    viewBox="0 0 332 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0264 0C8.51843 0 0 8.51842 0 19.0264V67.0702C0 77.5782 8.51841 86.0966 19.0264 86.0966H282.106C285.916 91.493 288.86 93.9269 294.101 96.1608C292.943 92.2134 292.33 89.1257 292.222 86.0966H312.479C322.987 86.0966 331.505 77.5782 331.505 67.0702V19.0264C331.505 8.51843 322.987 0 312.479 0H19.0264Z"
      fill="white"
    />
  </svg>
);

export const PlayIcon = ({
  size = 28,
  color,
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.0932 19.8629L30.093 19.8628L15.4276 9.86358C15.4274 9.86349 15.4273 9.86339 15.4271 9.8633C15.3745 9.82782 15.3082 9.82472 15.2542 9.85308C15.2002 9.88179 15.166 9.93825 15.166 10.0003V30.0003C15.166 30.0623 15.2001 30.1186 15.2546 30.1474L15.257 30.1486C15.2789 30.1603 15.3048 30.167 15.3327 30.167C15.3644 30.167 15.3974 30.1574 15.4263 30.1379L30.0932 19.8629ZM30.0932 19.8629C30.1389 19.894 30.166 19.9455 30.166 20.0003C30.166 20.0551 30.1389 20.1066 30.0932 20.1378L30.093 20.1379L15.4267 30.1376L30.0932 19.8629ZM15.4993 28.7383V29.6843L16.281 29.1514L29.0977 20.4134L29.7036 20.0003L29.0977 19.5872L16.281 10.8492L15.4993 10.3163V11.2623V28.7383Z"
      fill={color ? color : 'black'}
      stroke={color ? color : '#B8BFFF'}
    />
    <path
      d="M0.5 20C0.5 9.24814 9.24814 0.5 20 0.5C30.7519 0.5 39.5 9.24814 39.5 20C39.5 30.7519 30.7519 39.5 20 39.5C9.24814 39.5 0.5 30.7519 0.5 20ZM0.833333 20C0.833333 30.5688 9.43119 39.1667 20 39.1667C30.5688 39.1667 39.1667 30.5688 39.1667 20C39.1667 9.43119 30.5688 0.833333 20 0.833333C9.43119 0.833333 0.833333 9.43119 0.833333 20Z"
      fill={color ? color : 'black'}
      stroke={color ? color : 'url(#paint0_linear_523_123)'}
    />
    <defs>
      <linearGradient
        id="paint0_linear_523_123"
        x1="20"
        y1="0"
        x2="20"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7B78EA" />
        <stop offset="1" stopColor="#05FFFF" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
export const ShareIconV3 = ({ color = '#ffffff' }: IIconProps) => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
  >
    <path d="M15.5 6.00008L9.66667 0.166748V3.50008C3.83333 4.33341 1.33333 8.50008 0.5 12.6667C2.58333 9.75008 5.5 8.41675 9.66667 8.41675V11.8334L15.5 6.00008Z" />
  </svg>
);

export const CrossIcon = ({ size = 24, color = 'white' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
      fill={color}
    />
  </svg>
);

export const OfferIcon = ({ size = 19 }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00216 0.447619C8.38086 0.413162 8.76262 0.455821 9.12438 0.573021C9.48613 0.690221 9.82038 0.879529 10.1069 1.12951L10.2476 1.26083L17.5843 8.59844C18.0892 9.10346 18.3832 9.78156 18.4067 10.4953C18.4303 11.209 18.1815 11.905 17.7109 12.4422L17.5843 12.5772L12.2783 17.8833C11.7733 18.3882 11.0952 18.6822 10.3814 18.7057C9.66769 18.7292 8.97171 18.4805 8.43456 18.0099L8.29949 17.8833L0.960937 10.5456C0.69219 10.2769 0.480667 9.95652 0.33913 9.6038C0.197592 9.25109 0.128973 8.87335 0.137413 8.49339L0.14773 8.30111L0.590445 3.43782C0.647283 2.81106 0.912587 2.22145 1.34395 1.76322C1.77532 1.30498 2.34785 1.00458 2.97004 0.91003L3.13793 0.890333L8.00216 0.447619ZM5.64508 5.94497C5.47085 6.1192 5.33265 6.32604 5.23835 6.55368C5.14406 6.78132 5.09553 7.02531 5.09553 7.27171C5.09553 7.51811 5.14406 7.76209 5.23835 7.98973C5.33265 8.21737 5.47085 8.42421 5.64508 8.59844C5.81931 8.77267 6.02615 8.91088 6.25379 9.00517C6.48144 9.09946 6.72542 9.148 6.97182 9.148C7.21822 9.148 7.4622 9.09946 7.68984 9.00517C7.91748 8.91088 8.12433 8.77267 8.29856 8.59844C8.65043 8.24657 8.84811 7.76933 8.84811 7.27171C8.84811 6.77408 8.65043 6.29684 8.29856 5.94497C7.94668 5.5931 7.46944 5.39542 6.97182 5.39542C6.4742 5.39542 5.99695 5.5931 5.64508 5.94497Z"
      fill="#B49411"
    />
  </svg>
);

export const DownloadIcon = ({ size = 19 }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 14L11.2929 14.7071L12 15.4142L12.7071 14.7071L12 14ZM13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44771 11 5L13 5ZM6.29289 9.70711L11.2929 14.7071L12.7071 13.2929L7.70711 8.29289L6.29289 9.70711ZM12.7071 14.7071L17.7071 9.70711L16.2929 8.29289L11.2929 13.2929L12.7071 14.7071ZM13 14L13 5L11 5L11 14L13 14Z"
      fill="#ffffff"
    />
    <path
      d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
      stroke="#ffffff"
      strokeWidth="2"
    />
  </svg>
);

export const CheckIcon = ({ size = 24, color = '#222222' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill={'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.76822 12.6402L13.7682 6.64018L12.2318 5.35982L7.9328 10.5186L5.70711 8.29289L4.29289 9.70711L7.29289 12.7071L8.0672 13.4814L8.76822 12.6402Z"
      fill={color}
    />
  </svg>
);
